// extracted by mini-css-extract-plugin
export default {"pageHeader":"pageHeader__INgrL","contextHolder":"contextHolder__aS78s","context":"context__aXCM9","tree":"tree__XMDtN","editor":"editor__WP1XH"};